import { render, staticRenderFns } from "./BnplApplicationBaseData.vue?vue&type=template&id=5dc7d560&scoped=true&"
import script from "./BnplApplicationBaseData.vue?vue&type=script&lang=js&"
export * from "./BnplApplicationBaseData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc7d560",
  null
  
)

export default component.exports